import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "react-image-gallery/styles/css/image-gallery.css";
import "react-image-lightbox/style.css";
import { Provider } from "react-redux";
import ScrollToTop from "react-scroll-to-top";
import useIsMobile from "./customHooks/useIsMobile";
import "react-tabs/style/react-tabs.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-tooltip/dist/react-tooltip.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import App from "./App";
import { LanguageContextProvider } from "./Context/LanguageContext";
import ErrorBoundary from "./ErrorBoundary";
import InitLocation from "./InitLocation/InitLocation";
import store from "./Redux/Store/Store";
const root = ReactDOM.createRoot(document.getElementById("root"));

function RootApp() {
  const isMobile = useIsMobile();
  return (
    <StrictMode>
      <Provider store={store}>
        <LanguageContextProvider>
          <ErrorBoundary>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick={false}
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
            <InitLocation />
            <QueryClientProvider client={queryClient}>
              <App />
            </QueryClientProvider>
            {!isMobile && <ScrollToTop smooth color='#6f00ff' />}
          </ErrorBoundary>
        </LanguageContextProvider>
      </Provider>
    </StrictMode>
  );
}

// React Query Client
const queryClient = new QueryClient();

root.render(<RootApp />);
